import axios from '@axios'

const getInitialState = () => ({
  reportData: null,
  motoboys: [],
  filters: {
    storeId: null,
    motoboyId: null,
    deliveryStatus: null,
    period: {
      startDate: null,
      endDate: null,
    },
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getComboMotoboys(state) {
      return state.motoboys.map(motoboy => ({
        value: motoboy.id,
        label: motoboy.name,
      }))
    },
  },

  mutations: {
    SET_REPORT_DATA(state, reportData) {
      state.reportData = reportData
    },
    SET_MOTOBOYS(state, motoboys) {
      state.motoboys = motoboys
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_FILTERS(state) {
      const { filters } = getInitialState()
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, motoboys, reportData } = getInitialState()
      state.filters = filters
      state.motoboys = motoboys
      state.reportData = reportData
    },
  },

  actions: {
    async fetchMotoboys({ state, commit }) {
      const { storeId } = state.filters
      if (!storeId) {
        commit('SET_MOTOBOYS', [])
        return
      }

      const response = await axios.get('/api/suppliers/motoboys', {
        params: { storeId },
      })
      commit('SET_MOTOBOYS', response.data ?? [])
    },

    async generateReport({ state, commit }) {
      const { period } = state.filters
      const response = await axios.get('/api/reports/motoboy-deliveries/download', {
        params: {
          storeId: state.filters?.storeId,
          motoboyId: state.filters?.motoboyId,
          deliveryStatus: state.filters?.deliveryStatus,
          startDate: period?.startDate,
          endDate: period?.endDate,
        },
        responseType: 'blob',
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      commit('SET_REPORT_DATA', url)
    },

    setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('CLEAN_FILTERS')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
